import { ReactNode, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useAuthStore } from '../store/authStore';
import { ChangePasswordModal } from './ChangePasswordModal';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link
                to={user?.role === 'admin' ? '/dashboard' : user?.student_id ? `/students/${user.student_id}` : '/'}
                className="text-xl font-semibold text-gray-900"
              >
                Dashboard
              </Link>
            </div>

            <div className="flex items-center space-x-4">
              <Link
                to="/"
                className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium"
              >
                Trang Chủ
              </Link>
              {user?.role === 'admin' && (
                <>
                  <Link
                    to="/students"
                    className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    DS Học Sinh
                  </Link>
                  <Link
                    to="/tests"
                    className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    DS Bài Kiểm Tra
                  </Link>
                  <Link
                    to="/results"
                    className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Kết quả
                  </Link>
                  <Link
                    to="/categories"
                    className="text-gray-700 hover:text-blue-600 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Categories
                  </Link>
                </>
              )}

              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-700">
                  {user?.username} ({user?.student_name})
                </span>
                <button
                  onClick={() => setShowPasswordModal(true)}
                  className="bg-gray-600 text-white px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-700"
                >
                  Đổi Mật Khẩu
                </button>
                <button
                  onClick={handleLogout}
                  className="bg-blue-600 text-white px-3 py-2 rounded-md text-sm font-medium hover:bg-blue-700"
                >
                  Đăng Xuất
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        {children}
      </main>

      <ChangePasswordModal
        isOpen={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
      />
    </div>
  );
};
